// extracted by mini-css-extract-plugin
export var core = "upcomingProjects-module--core--MsZGP";
export var details = "upcomingProjects-module--details--JKKF7";
export var header = "upcomingProjects-module--header--i6jHU";
export var cover = "upcomingProjects-module--cover--tSjW+";
export var image = "upcomingProjects-module--image--vxm3v";
export var content = "upcomingProjects-module--content--cXz56";
export var description = "upcomingProjects-module--description--Odz0s";